/** Global handler for API 401 — wired from AuthProvider bridge (avoids import cycles).
 *
 * Debounce: parallel 401 responses call handler at most once per microtask window
 * (see handling flag + queueMicrotask reset) to avoid logout loops.
 *
 * Opt-out: set error.config.skipUnauthorizedLogout = true on specific requests.
 * Local dev bypass is handled in Unauthorized401Bridge (no logout when bypass on).
 */

let handler = null;
let handling = false;

/** @param {(() => void) | null} fn */
export function setUnauthorized401Handler(fn) {
  handler = fn;
}

/** @param {import('axios').AxiosError} error */
export function shouldHandleUnauthorized401(error) {
  if (error?.response?.status !== 401) {
    return false;
  }
  if (error?.config?.skipUnauthorizedLogout) {
    return false;
  }
  if (error?.config?.skipAuthRetry) {
    return false;
  }
  return true;
}

export function notifyUnauthorized401() {
  if (handling || !handler) {
    return;
  }
  handling = true;
  try {
    handler();
  } finally {
    queueMicrotask(() => {
      handling = false;
    });
  }
}

/** Test helper — reset debounce flag between cases. */
export function resetUnauthorized401Handling() {
  handling = false;
}
